import React, { useRef, useState, useEffect } from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";

// Import Swiper styles
import "swiper/css";

import loginImage from "../../assests/images/loginImage.svg";
import "./LoginCarousel.scss";

export default function LoginCarousel() {
  return (
    <div className="login_carousel">
      <Swiper watchSlidesProgress={true} slidesPerView={1} style={{ height: "100%" }} loop={true} pagination={true}>
        <SwiperSlide style={{ height: "100%" }}>
          <div className="custom_card carousel_card">
            <div className="card_image">
              <img src={loginImage} alt="" />
            </div>
            <div className="card_body">
              <div className="card_title">Video Lectures</div>
              <div className="card_description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, fuga?</div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide style={{ height: "100%" }}>
          <div className="custom_card carousel_card">
            <div className="card_image">
              <img src={loginImage} alt="" />
            </div>
            <div className="card_body">
              <div className="card_title">Video Lectures</div>
              <div className="card_description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, fuga?</div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide style={{ height: "100%" }}>
          <div className="custom_card carousel_card">
            <div className="card_image">
              <img src={loginImage} alt="" />
            </div>
            <div className="card_body">
              <div className="card_title">Video Lectures</div>
              <div className="card_description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, fuga?</div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
